import styled from "styled-components";

export const LoginStepBtnStyled = styled.div`
  position: absolute;
  right: 0;
  left: 0;
  bottom: 24px;
  text-align: center;
  padding: 0 24px;

  button {
    border-radius: 14px;
    box-shadow: 0 4px 10px 0 rgba(255, 191, 29, 0.2);
    background-color: #ffbf1d;
    text-align: center;
    height: 48px;
    width: 100%;

    font-weight: bold;
    font-size: 1.3em;
    color: white;
  }
`;
